import React, { Suspense } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { THEME } from "../constants/Settings";
import { RO_INSTITUTION_PAGE } from "../constants/Routes";

// Saturday Education ("C191Z26ROYAL58") has its own course finder UI. Keep the comparison
// inline on process.env (not the CLIENT_ID constant): webpack then drops the Saturday
// imports from every other client's build.
const HomePage = React.lazy(() =>
  process.env.REACT_APP_CLIENT_ID === "C191Z26ROYAL58"
    ? import(
        /* webpackChunkName: "saturday-course-finder" */ "../clients/saturdayEducation/SaturdayCourseFinder.page"
      )
    : import(`../themes/${THEME}/pages/HomePage/HomePage.page`),
);

const InstitutionPage = React.lazy(
  () => import(`../themes/${THEME}/pages/Institution/institution.page`),
);

const EmbeddableProgramsPage = React.lazy(() =>
  process.env.REACT_APP_CLIENT_ID === "C191Z26ROYAL58"
    ? import(
        /* webpackChunkName: "saturday-course-finder" */ "../clients/saturdayEducation/SaturdayEmbeddedCourseFinder.page"
      )
    : import(
        `../themes/${THEME}/pages/EmbeddablePrograms/EmbeddablePrograms.page`
      ),
);

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        {/* <RouteMiddleware> */}
        <HomePage />
        {/* </RouteMiddleware> */}
      </Suspense>
    ),
  },
  {
    path: `${RO_INSTITUTION_PAGE}/:university`,
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        {/* <RouteMiddleware> */}
        <InstitutionPage />
        {/* </RouteMiddleware> */}
      </Suspense>
    ),
  },
  {
    path: "/embeddable-programs",
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <EmbeddableProgramsPage />
      </Suspense>
    ),
  },
]);

export default function App() {
  //   const { setSessionId } = useSiteState();

  //   useEffect(() => {
  //     setSessionId();
  //   }, [setSessionId]);

  return <RouterProvider router={router} />;
}
